<template>
  <comment :is="appLayout">
    <router-view/>
  </comment>
</template>

<script>
  const defaultAppLayout = 'default';

  export default {
    data () {
      return {}
    },
    name: 'App',
    computed: {
      /* determine the application layout to use based on the route */
      appLayout() {
        return (this.$route.meta.layout || defaultAppLayout) + '-layout';
      }
    },
    created: function () {
      let self = this;
      axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
            self.$store.dispatch('logout').then();
            self.$router.push('/login');
          }
          throw err;
        });
      });
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue